import * as R from "ramda";
import { useEffect } from "react";

export default function useHashSlash() {
  // if the url doesn't end in a slash, add it
  useEffect(() => {
    // NOTE using window.location instead of react-router location
    const { pathname, hash, search } = window.location;

    if (!R.test(/\/$/, pathname)) {
      window.history.replaceState(null, null, pathname + "/" + search + hash);
    }
  }, []);
}
